// Specialized form field for numeric inputs
import React from 'react';
import { FormField } from './FormField';
import { TextInputProps } from '@/components/common/text';

interface NumericFormFieldProps extends Omit<TextInputProps, 'keyboardType'> {
  label: string;
  error?: string;
  required?: boolean;
  helpText?: string;
}

export const NumericFormField: React.FC<NumericFormFieldProps> = (props) => {
  return (
    <FormField
      {...props}
      keyboardType="numeric"
    />
  );
};

